import { useEffect, useRef } from 'react';
import classnames from 'classnames/bind';

import { loadScript } from '@autopass-web/domain';
import { CoreIcon } from '@autopass-web/mochi-icons';

import styles from './index.module.sass';
const cx = classnames.bind(styles);

declare global {
  interface Window {
    YT: any;
    onYouTubeIframeAPIReady: any;
  }
}

interface YoutubeModalPrps {
  videoId: string;
  show: boolean;
  onClose: () => {};
}

const YoutubeModal = ({ videoId, show, onClose }: YoutubeModalPrps) => {
  const iframeContainerRef = useRef<HTMLDivElement | null>(null);
  const iframePlayer = document.createElement('div');
  iframePlayer.id = 'iframe-player';

  useEffect(() => {
    loadScript('https://www.youtube.com/iframe_api');
  }, []);

  useEffect(() => {
    const loadVideo = () => {
      if (iframeContainerRef?.current) {
        iframeContainerRef.current.appendChild(iframePlayer);
      }

      const onPlayerReady = (event: any) => {
        event.target.playVideo();
      };

      new window.YT.Player('iframe-player', {
        height: '100%',
        width: '100%',
        videoId,
        playerVars: {
          autoplay: 1,
          controls: 0,
          rel: 0,
          fs: 0,
          loop: 1,
          modestbranding: 1,
          showinfo: 0,
        },
        events: {
          onReady: onPlayerReady,
        },
      });
    };

    if (show) {
      if (!window.YT) {
        window.onYouTubeIframeAPIReady = loadVideo;
      } else {
        loadVideo();
      }
    } else {
      if (
        iframeContainerRef.current &&
        iframeContainerRef.current.childNodes.length > 0
      ) {
        const child = iframeContainerRef.current.firstChild;
        if (child) {
          iframeContainerRef.current.removeChild(child);
        }
      }
    }
  }, [show, iframePlayer]); // eslint-disable-line

  const videoClass = cx({
    video: true,
    show,
  });

  return (
    <div className={videoClass}>
      <div
        className={styles['close']}
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
      >
        <CoreIcon src="../../assets/close.svg" />
      </div>
      <div ref={iframeContainerRef} />
    </div>
  );
};

export default YoutubeModal;
